import React, { useMemo } from 'react';

import Button from '@adsk/alloy-react-button';
import { MagnifyingGlassIcon, XCircleFilledIcon } from '@adsk/alloy-react-icon';
import theme from '@adsk/alloy-react-theme';
import Tooltip from '@adsk/alloy-react-tooltip';

import { useTranslation } from '../i18n';

const countableFilters = ['searchExpression', 'setId', 'tags'];

const SearchFilterButton = ({
  filters,
  filtersOpen,
  disabled,
  clearFilters,
  onClick,
}) => {
  const { t } = useTranslation();

  const filtersCount = useMemo(
    () =>
      Object.keys(filters).filter((key) => countableFilters.includes(key))
        .length,
    [filters],
  );

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        marginLeft: '12px',
        border: `1px solid ${theme.colors.charcoal400}`,
        borderRadius: '2px',
      }}
    >
      <Button
        style={{
          border: 'none',
          borderRadius: 0,
          ...(!filtersOpen && {
            '&:hover': {
              background: theme.colors.charcoal050,
              color: theme.colors.charcoal900,
            },
          }),
        }}
        selected={filtersOpen}
        renderIcon={MagnifyingGlassIcon.renderIcon}
        onClick={onClick}
        disabled={disabled}
      >
        {t(
          filtersCount ? 'SEARCH_AND_FILTER_WITH_COUNT' : 'SEARCH_AND_FILTER',
          {
            count: filtersCount,
          },
        )}
      </Button>
      {!!filtersCount && (
        <Tooltip content={t('CLEAR_SEARCH_AND_FILTER')}>
          <Button
            style={{
              border: 'none',
              borderLeft: `1px solid ${theme.colors.charcoal400}`,
              borderRadius: 0,
              ...(!filtersOpen && {
                '&:hover': {
                  background: theme.colors.charcoal050,
                  color: theme.colors.charcoal900,
                },
              }),
            }}
            renderIcon={XCircleFilledIcon.renderIcon}
            onClick={clearFilters}
          />
        </Tooltip>
      )}
    </div>
  );
};

export default SearchFilterButton;
